import $ from 'cash-dom'
import { debounce, removeAccents } from '../utilities/toolkit'
import { updateCartAttributes } from '../resources/shopify-cart'
import { slideOpen, slideClosed } from '../utilities/animations'

const giftMessageForm = document.getElementById('cart-message-form')
const cartCharCount = $('[data-content="cart-message-char-count"]')
const cartToField = document.getElementById('cart-message-to')
const cartFromField = document.getElementById('cart-message-from')
const cartMessage = document.getElementById('cart-message')

const saveMessageToCart = () => {
  const attributesToSend = {
    _gift_message: cartMessage ? cartMessage.value : '',
  }

  if (cartToField) {
    attributesToSend._gift_message_to = cartToField.value
  }
  if (cartFromField) {
    attributesToSend._gift_message_from = cartFromField.value
  }
  updateCartAttributes(attributesToSend)
}

const checkMessageField = (e) => {
  // 40 for to and from fields
  let charLimit = 40
  // 220 for message field
  if (e.target.id == 'cart-message') {
    charLimit = 220
  }

  let value = e.target.value
  value = removeAccents(value)
  value = value.replaceAll(/[^a-zA-Z0-9 .,?!@#$();:<>_-]/g, '')

  if (value.length > charLimit) {
    value = value.substring(0, charLimit)
  }

  e.target.value = value

  if (e.target.id == 'cart-message') {
    cartCharCount.html(value.length)
  }
}

$('[data-action="cart-message-changed"]').on('input', (e) =>
  checkMessageField(e)
)

$('[data-action="cart-message-changed"]').on(
  'input',
  debounce((e) => {
    saveMessageToCart(e)
  }, 600)
)

$('[data-action="toggle-cart-gift-message"]').on('change', (e) => {
  // show message panel
  if (e.target.checked) {
    slideOpen(giftMessageForm)

    // Scroll the cart-full-item into view after opening the form
    setTimeout(() => {
      const cartFullItem = document.querySelector(
        '[data-element="cart-full-item"]'
      )
      if (cartFullItem) {
        cartFullItem.scrollTo({
          top: cartFullItem.scrollHeight,
          behavior: 'smooth',
        })
      }
    }, 300) // Adjust delay as needed to match your animation

    return
  }

  // hide message panel
  slideClosed(giftMessageForm)

  // clear fields if they exist
  if (cartToField) cartToField.value = ''
  if (cartFromField) cartFromField.value = ''
  if (cartMessage) cartMessage.value = ''
  cartCharCount.html('0')

  // clear cart attributes
  const attributesToClear = {
    _gift_message: null,
    _gift_message_to: null,
    _gift_message_from: null,
  }

  updateCartAttributes(attributesToClear)
})
